namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CvmCampaignGrid')
    export class CvmCampaignGrid extends Serenity.EntityGrid<CvmCampaignRow, any> {
        protected getColumnsKey() { return CvmCampaignColumns.columnsKey; }
        protected getDialogType() { return CvmCampaignDialog; }
        protected getIdProperty() { return CvmCampaignRow.idProperty; }
        protected getInsertPermission() { return CvmCampaignRow.insertPermission; }
        protected getLocalTextPrefix() { return CvmCampaignRow.localTextPrefix; }
        protected getService() { return CvmCampaignService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}